import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { POPUP } from 'utils/constants/popup';
import { ReactComponent as MessageIcon } from 'assets/icons/message-text.svg';
import { openPopup } from 'modules/popup/actions';
import './style.css';

const AssistanceButton = ({ title = 'Need Assistance?', onClick }) => {
  const dispatch = useDispatch();
  return (
    <div
      className="assistance-btn"
      onClick={() => {
        dispatch(openPopup({
          type: POPUP.ASSISTANCE_CHAT,
        }));

        if (onClick) {
          onClick();
        }
      }}
    >
      <MessageIcon />
      <span className="label">
        {title}
      </span>
    </div>
  );
};

AssistanceButton.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default AssistanceButton;
